'use client';

import Image from "next/image";
import AnimatedHeight from "../AnimatedHeight";
import { Text } from "../Text";
import { TextCombination } from "../TextCombination";
import { Callout } from "./Callout";
import { CarouselTimelineItemProps } from "./index";

export const MobileTimelineItem = ({ eyebrow, title, description, calloutTitle, calloutDescription, isActive, onClick, imageSrc }: CarouselTimelineItemProps) => {
  return (
    <div className="md:hidden surface-l1 flex flex-col text-left p-lg rounded-10 cursor-pointer" onClick={onClick}>
      <TextCombination
        type="h1p1"
        align="left"
        eyebrow={eyebrow}
        title={title}
      />
      <AnimatedHeight
        isExpanded={isActive}
        className="flex flex-col gap-y-lg"
      >
        <Text type="p2" className="text-primary">{description}</Text>
        <Image src={imageSrc} alt={title} width={500} height={500} />
        {calloutTitle && calloutDescription && (
          <Callout title={calloutTitle} description={calloutDescription} backgroundLevel="l2" />
        )}
      </AnimatedHeight>
    </div>
  );
}
